import Image from "next/image";

import { profileData, socialMedia } from "@/data";

const Footer = () => {
  return (
    <footer className="w-full py-10 border-t border-white/10">
      <div className="flex gap-4 md:flex-row flex-col justify-between items-center">
        <p className="md:text-base text-sm md:font-normal font-light">
          © {new Date().getFullYear()} {profileData.name}. All rights reserved.
        </p>
        <p className="text-white-200 text-sm tracking-[0.08em]">
          {profileData.heroTagline}
        </p>

        <div className="flex items-center md:gap-3 gap-6">
          {socialMedia.map((info) => {
            const isMailLink = info.link.startsWith("mailto:");

            return (
              <a
                key={info.id}
                href={info.link}
                target={isMailLink ? undefined : "_blank"}
                rel={isMailLink ? undefined : "noopener noreferrer"}
                aria-label={info.alt}
                className="w-10 h-10 cursor-pointer flex justify-center items-center backdrop-filter backdrop-blur-lg saturate-180 bg-opacity-75 bg-black-200 rounded-lg border border-black-300"
              >
                <Image src={info.img} alt={info.alt} width={20} height={20} />
              </a>
            );
          })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
